import React from "react";
import { Line } from "react-chartjs-2";
import { useTranslation } from 'react-i18next'


const DualLine = props => {
  const { t } = useTranslation();

  const { alldata } = props
  // Check if bloodPressureData is defined before using it
  if (!alldata || alldata.length === 0) {
    return <div style={{ textAlign: 'center', marginLeft: '30px', marginBottom: '10px', marginTop: '5px' }}>{t('No data available')}</div>;
  }


  // Define chart options
  const options = {
    plugins: {
      legend: false,
      tooltips: {
        intersect: false,
      },
      hover: {
        intersect: true,
      }
    },
    scales: {
      y: {
        ticks: {
          beginAtZero: true,
          max: 100,
          min: 0,
          stepSize: 20,
          padding: 10,
        },
      },
      x: {
        ticks: {
          padding: 5,
        },
      },
    },
  };


  const chartData = {
    labels: alldata.map(data => data.testDate),
    datasets: [

      {

        label: "sugarLevel",
        data: alldata.map(data => data.sugarLevel),
        borderColor: "red",
        borderWidth: "2",
        backgroundColor: "transparent",
        pointBackgroundColor: "rgba(235,129,83,1)",
        tension: 0.4

      },


    ],
  };


  return (

    <div  className="bpsugar-responsive-wavechart">
    {/* <div style={{ maxWidth: "60%", position: 'relative', left: '15%' }}> */}
      <Line data={chartData} options={options} height={450} width={800}/>
    </div>
  );
}

export default DualLine;
